import script from "./ContestManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ContestManagement.vue?vue&type=script&setup=true&lang=js"

import "./ContestManagement.vue?vue&type=style&index=0&id=5b47312b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b47312b"]])

export default __exports__